import { useEffect } from 'react';
import { Button, Form, FormField, FormGroup, Input, Label, Modal } from 'semantic-ui-react';
import './ProfileModal.scss';

interface ProfileModalProps {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onSave: () => void;
}

function ProfileModal({open, setOpen, onSave}:ProfileModalProps) {
  useEffect(()=>{
  }, [open])
    return <Modal
        open={open}
        onClose={() => setOpen(false)}
        className='profile-modal'
        centered
        closeIcon
        size='tiny'
    >
        <Modal.Header>Профиль</Modal.Header>
        <Modal.Content>
            <Form>
                <FormGroup widths='equal'>
                    <Form.Input required fluid label='Имя' placeholder='Имя' />
                    <Form.Input required fluid label='Фамилия' placeholder='Фамилия' />
                </FormGroup>
                <Form.TextArea fluid label='О себе' placeholder='О себе' />
                <FormField>
                    <Input label={<Label basic>https://story-maker.pro/</Label>} placeholder='Укажите ссылку' />
                </FormField>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button basic onClick={() => setOpen(false)}>Отменить</Button>
            <Button primary onClick={() => {onSave();setOpen(false)}}>Сохранить</Button>
        </Modal.Actions>
    </Modal>
};

export default ProfileModal;